import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import { get, find } from "lodash";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import {
  resetSelectDate,
  resetSelectTimeSlot,
  resetSchedule,
  addSchedule,
  changeDirection,
  goBackStep,
  getBookingTree,
  setScheduleWithoutDate
} from "~/store/totalData/actions";
import { MDBSpinner } from "mdbreact";
import { requestHoliday } from "~/store/resource/resourceAction";
import { resetStatusScanQrCodeInsurance } from "~/store/patient/patientAction";
import { getPartnerFromUrl } from "~/utils/func";
import { partnerInfo } from "~/configs/partnerDetails";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const ChooseCalendarDesktop = Loadable({
  loader: () => import("~/components/desktop/pages/Schedules/ChooseCalendar"),
  loading: LoadableLoading
});
class ChooseCalendar extends Component {
  componentDidMount() {
    const {
      resetSchedule,
      resetSelectDate,
      resetSelectTimeSlot,
      requestHoliday,
      resetStatusScanQrCodeInsurance,
      getBookingTree,
      listDays,
      setScheduleWithoutDate
    } = this.props;

    const currentPagePartnerId = getPartnerFromUrl(
      this.props.history.location.pathname
    );

    if (listDays.length === 0) {
      getBookingTree("", currentPagePartnerId);
    }

    resetSchedule();
    resetSelectDate();
    resetSelectTimeSlot();
    requestHoliday();
    resetStatusScanQrCodeInsurance(); // reset chỗ scan mã BHYT
    setScheduleWithoutDate(false);
  }

  methods = {
    handleNextStep: () => {
      const { history, addSchedule } = this.props;
      addSchedule();
      history.push("/chon-ho-so");
    },
    handleGoBack: () => {
      this.props.goBackStep("calendar");
    }
  };

  render() {
    const { listDays } = this.props;

    if (listDays.length === 0) {
      return (
        <div className="loading">
          <MDBSpinner big />
        </div>
      );
    }
    return (
      <React.Fragment>
        <ChooseCalendarDesktop {...this.props} {...this.methods} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    hospital: { selectedHospital },
    patient: { selectedPatient },
    totalData: {
      timeSlot: { timeId },
      days: { date: dateSelected, list: listDays },
      listNode,
      partnerId,
      service: { serviceType }
    },
    user: { IsAuthenticated },
    followUpExam: { patientExam }
  } = state;
  return {
    device: type,
    selectedHospital,
    selectedPatient,
    serviceType,
    timeId,
    IsAuthenticated,
    dateSelected,
    listNode,
    partnerId,
    listDays,
    patientExam
  };
};

const ChooseCalendarHelmet = withTitle({
  component: ChooseCalendar,
  title: `${hospitalName.value} | Chọn lịch khám`
});

export default connect(mapStateToProps, {
  resetSelectDate,
  resetSelectTimeSlot,
  resetSchedule,
  addSchedule,
  changeDirection,
  requestHoliday,
  resetStatusScanQrCodeInsurance,
  goBackStep,
  getBookingTree,
  setScheduleWithoutDate
})(ChooseCalendarHelmet);
